import React from 'react';

export function getPersonInitials(name: string): string {
	if (!name) return "";
	const
		parts = name.split(' '),
		partsInitials = parts.map((p) => p[0]);

	return partsInitials.join('');
}

export interface IMatchIndex {
	start: number;
	length: number;
	text: string;
	className?: string;
	tooltip?: string;
}

export function highlightText_matches(text: string, matchIndexes: IMatchIndex[]): string | JSX.Element[] {
	const elements = [];

	let lastEndIndex = 0;
	for (let index = 0; index < matchIndexes.length; index++) {
		const match = matchIndexes[index];
		if (match.start != lastEndIndex) {
			elements.push(text.substr(lastEndIndex, match.start - lastEndIndex));
		}
		const matchText = match.text || text.substr(match.start, match.length);
		elements.push(<em key={index} className={match.className} title={match.tooltip}>{matchText}</em>);
		lastEndIndex = match.start + match.length;
	}
	if (lastEndIndex != text.length) {
		elements.push(text.substr(lastEndIndex, text.length - lastEndIndex));
	}
	return elements;
}

export function highlightText(text: string, textRe: RegExp): string | JSX.Element[] {
	let match = textRe.exec(text);
	const matchIndexes = [];

	while (match != null) {
		matchIndexes.push({ start: match.index, length: match[0].length, text: match[1]} as IMatchIndex);
		match = textRe.exec(text);
	}
	
	if (matchIndexes.length == 0) {
		return text;
	} else {
		return highlightText_matches(text, matchIndexes);
	}
}

export function highlightTextMulti(text: string, textRes: RegExp[]): string | JSX.Element[] {
	const matchIndexes = [];
	
	for (let index = 0; index < textRes.length; index++) {
		const textRe = textRes[index];
		let match = textRe.exec(text);

		while (match != null) {
			matchIndexes.push({ start: match.index, length: match[0].length, text: match[1]} as IMatchIndex);
			match = textRe.exec(text);
		}
	}
	
	if (matchIndexes.length == 0) {
		return text;
	} else {
		return highlightText_matches(text, matchIndexes);
	}
}